import Grid from '@mui/material/Grid';
import DataField from '../../atoms/dataField';
import React, { FC, useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { CONNECTION_TYPES } from '../../../constants/_pickerValues';
import { IFormField } from '../../shared/globalTypes';


interface Props {
    selectedConnection: string,
    hostName: IFormField,
    accessToken: IFormField,
    onChange: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement> | undefined,
    kmsId?: IFormField
}

const ConnectionFoundry: FC<Props> = ({ selectedConnection, hostName, accessToken, onChange }: Props) => {
    const [visible, setVisible] = useState(false);


    useEffect(() => {
        if (selectedConnection === CONNECTION_TYPES.foundry) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    }, [selectedConnection]);

    if (visible) {
        return (
            <Box sx={{ border: 1, borderColor: 'divider', padding: 3, width: '100%' }}>
                <h2>{selectedConnection}</h2>
                <Grid container spacing={4}>
                    <Grid item xs={4}>
                        <DataField id="e96fe82b-df73-46fb-bb1a-f532fa1fc05a"
                            label='Host Name'
                            name='hostName'
                            type='text'
                            required={true}
                            onChange={onChange}
                            value={hostName.fieldValue}
                            error={hostName.isError}
                        />
                    </Grid>
                    <Grid item xs={8}>
                        <DataField id="7c11f574-2a85-4f20-865f-822c9c83b438"
                            label='Access Token'
                            name='accessToken'
                            type='text'
                            required={true}
                            onChange={onChange}
                            value={accessToken.fieldValue}
                            error={accessToken.isError}
                        />
                    </Grid>
                </Grid>
            </Box >
        )
    } else {
        return <></>;
    }

};

export default ConnectionFoundry;